import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
// External dependencies
import { useContext, memo, } from 'react';
import { Grid, TextField, } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
// Internal dependencies
import { appStyles } from '../App.styles';
import { UserContext } from '../auth';
import { SelectSG, AIModelSelectSG } from '../components';
import { AI_MODELS, AI_PROVIDER_TYPES, IMAGE_SIZES, OUTPUT_TYPES } from './constants';
import { aiModels } from '../constants';
import { CLIENT_ENDPOINTS } from '../constants';
/**
 * Chat Title component
 * @param props props
 * @returns Chat Title element
 */
export const ChatTitle = memo(function ({ chat, setChat, isDownMDBreakPoint, sx, }) {
    var _a, _b;
    const navigate = useNavigate();
    // Get user credential
    const user = useContext(UserContext);
    // Get translation function
    const { t, i18n } = useTranslation();
    const /** AI Model */ aiModel = (chat === null || chat === void 0 ? void 0 : chat.aiModel) || AI_MODELS.aiSearch.modelValue;
    return (_jsxs(Grid, Object.assign({ container: true, sx: Object.assign({}, sx) }, { children: [_jsx(Grid, Object.assign({ item: true, sx: { display: 'flex', alignItems: 'center' } }, { children: _jsx(TextField, { sx: { width: '100%' }, variant: "standard", InputProps: {
                        disableUnderline: isDownMDBreakPoint ? false : true,
                    }, inputProps: {
                        style: Object.assign(Object.assign({}, appStyles.text22), { fontWeight: 'medium', color: '#000000', padding: '0', height: 'auto', overflow: 'hidden', textOverflow: 'ellipsis', width: 'calc(100%)' })
                    }, value: chat === null || chat === void 0 ? void 0 : chat.title, onChange: (e) => { chat.title = e.target.value; setChat(Object.assign({}, chat)); }, placeholder: t('Untitled Project') || '' }) })), _jsx(Grid, Object.assign({ item: true }, { children: _jsxs(Grid, Object.assign({ container: true, columnSpacing: 1, sx: {
                        flexDirection: isDownMDBreakPoint ? 'row-reverse' : 'row',
                        justifyContent: 'flex-end',
                        flexWrap: 'nowrap',
                    } }, { children: [_jsx(Grid, { item: true }), _jsx(Grid, Object.assign({ item: true, sx: {
                                display: ((_a = AI_MODELS[aiModel]) === null || _a === void 0 ? void 0 : _a.outputType) === OUTPUT_TYPES.IMAGES
                                    && ((_b = AI_MODELS[aiModel]) === null || _b === void 0 ? void 0 : _b.aiProviderType) === AI_PROVIDER_TYPES.AZURE
                                    ? 'inline-flex'
                                    : 'none',
                            } }, { children: _jsx(SelectSG, { variant: "standard", disableUnderline: true, label: '', name: "size", items: IMAGE_SIZES, value: (chat === null || chat === void 0 ? void 0 : chat.imageSize) || IMAGE_SIZES[0].value, onChange: (event) => {
                                    chat.imageSize = event.target.value;
                                    setChat(Object.assign({}, chat));
                                }, xstyles: {
                                    padding: '0',
                                    maxWidth: '332px',
                                    width: '100%',
                                    '& .MuiInputBase-root div.MuiSelect-select': {
                                        backgroundColor: 'transparent!important',
                                    },
                                } }) })), _jsx(Grid, Object.assign({ item: true }, { children: _jsx(AIModelSelectSG, { variant: "standard", disableUnderline: true, label: '', name: "model", items: aiModels, value: user ? ((chat === null || chat === void 0 ? void 0 : chat.aiModel) || AI_MODELS.aiSearch.modelValue) : AI_MODELS.incognito.modelValue, isShowPopover: isDownMDBreakPoint ? false : true, onChange: (event) => {
                                    if (!user) {
                                        navigate(CLIENT_ENDPOINTS.SIGN_IN);
                                        return;
                                    }
                                    chat.aiModel = event.target.value;
                                    setChat(Object.assign({}, chat));
                                }, xstyles: {
                                    padding: '0',
                                    maxWidth: '332px',
                                    width: '100%',
                                    '& .MuiInputBase-root div.MuiSelect-select': {
                                        backgroundColor: 'transparent!important',
                                    },
                                } }) }))] })) }))] })));
});
